import { useEffect, useMemo, useState } from 'react';
import { useGetReportPnLLastYearVsTargetCurrentYear } from '../core/_query';
import { useQueryRequest } from '../core/QueryRequestProvider';
import { FormattedNumber, IntlProvider } from 'react-intl';
import moment from 'moment';
import DashboardPnLvsTargetTargetCard from './DashboardPnLvsTargetCard';
import { DropdownSelect } from '@/_metronic/partials/content/dropdown-select/DropdownSelect';

const DashboardPnLLastYearVsTargetCurrentYearCard = () => {
    const { state } = useQueryRequest();

    const [selectedYear, setSelectedYear] = useState<any>(null);
    const [selectedYearVersus, setSelectedYearVersus] = useState<any>(null);
    const [optionsYear, setOptionsYear] = useState<any[]>([]);

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 5 }, (_, index) => currentYear - 4 + index);
        const yearOptions = years.map((x) => ({ label: x, value: x }));
        setOptionsYear(yearOptions);
        setSelectedYear({label: currentYear, value: currentYear})
        setSelectedYearVersus({label: currentYear - 1, value: currentYear - 1})
    }, []);

    const { data: cardData, refetch } = useGetReportPnLLastYearVsTargetCurrentYear({
        ...state,
        year: selectedYearVersus?.value ?? state.year,
    });

    useEffect(() => {
        if (selectedYear && selectedYearVersus) {
            refetch();
        }
    }, [selectedYear, selectedYearVersus, refetch]);

    const data = useMemo(() => {
        return cardData?.response?.data;
    }, [cardData]);

    return (
        <div className='card'>
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>PnL vs Target</span>
                </h3>
                <div className='row align-items-center'>
                    <div className='col-auto'>
                        <DropdownSelect
                            options={optionsYear}
                            placeholder='Year'
                            value={selectedYear}
                            onChange={(value) => setSelectedYear(value)}
                        />
                    </div>
                    <div className='col-auto'>VS</div>
                    <div className='col-auto'>
                        <DropdownSelect
                            options={optionsYear}
                            placeholder='Year'
                            value={selectedYearVersus}
                            onChange={(value) => setSelectedYearVersus(value)}
                        />
                    </div>
                </div>
            </div>
            <div className='card-body'>
                <DashboardPnLvsTargetTargetCard year={selectedYear?.value ?? state.year} />
                <table className="table table-bordered table-sm text-center align-middle mt-10">
                    <thead className="table-light">
                        <tr>
                            <th className='w-125px'></th>
                            <th className='w-125px'>ACTUAL ({selectedYearVersus?.value || state.year})</th>
                            <th className='w-125px'>TARGET ({selectedYearVersus?.value || state.year})</th>
                            <th className='w-75px'>(+/-) %</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>REVENUE ALL</td>
                            <td>
                                <IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={data?.actual_last_year?.revenue_all || 0}
                                    />
                                </IntlProvider>
                            </td>
                            <td>
                                <IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={data?.target_current_year?.revenue_all || 0}
                                    />
                                </IntlProvider>
                                <br />
                                <small>({<IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={
                                            data?.difference?.revenue_all || 0
                                        }
                                    />
                                </IntlProvider>
                                })
                                </small>
                            </td>
                            <td>{data?.percentage?.revenue_all || '0%'}</td>
                        </tr>
                        <tr>
                            <td>REVENUE ALAYA</td>
                            <td>
                                <IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={data?.actual_last_year?.revenue_alaya || 0}
                                    />
                                </IntlProvider>
                            </td>
                            <td>
                                <IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={data?.target_current_year?.revenue_all || 0}
                                    />
                                </IntlProvider>
                                <br />
                                <small>({<IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={
                                            data?.target_current_year?.revenue_all || 0
                                        }
                                    />
                                </IntlProvider>
                                })
                                </small>
                            </td>
                            <td>{data?.percentage?.revenue_alaya || '0%'}</td>
                        </tr>
                        <tr>
                            <td>NOP</td>
                            <td>
                                <IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={data?.actual_last_year?.nop || 0}
                                    />
                                </IntlProvider>
                            </td>
                            <td>
                                <IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={data?.target_current_year?.nop || 0}
                                    />
                                </IntlProvider>
                                <br />
                                <small>({<IntlProvider locale='id'>
                                    <FormattedNumber
                                        value={
                                            data?.difference?.nop || 0
                                        }
                                    />
                                </IntlProvider>
                                })
                                </small>
                            </td>
                            <td>{data?.percentage?.nop || '0%'}</td>
                        </tr>
                        <tr>
                            <td>NET</td>
                            <td>
                                {data?.actual_last_year?.nett || '0%'}
                            </td>
                            <td>
                                {data?.target_current_year?.nett || 0}
                            </td>
                            <td>{data?.percentage?.nett || '0%'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DashboardPnLLastYearVsTargetCurrentYearCard;
